/**
 * GrowingGoals — Platform Admin страница мини-справочника «Цели выращивания»
 * (AK-231 Pilot, FR-6). Тонкий wrapper над `ReferenceMiniCatalog`.
 */
import { PlatformAdminLayout } from '@/layouts/PlatformAdminLayout';
import { ReferenceMiniCatalog } from '@/components/reference/ReferenceMiniCatalog';
import {
  useCreateGoal,
  useDeleteGoal,
  useGoals,
  useUpdateGoal,
} from './hooks/useReferenceQueries';
import { toast } from '@/lib/toast';

function plural(n: number): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 14) return 'культур';
  if (mod10 === 1) return 'культура';
  if (mod10 >= 2 && mod10 <= 4) return 'культуры';
  return 'культур';
}

export function PlatformAdminGrowingGoalsPage() {
  const q = useGoals();
  const createMut = useCreateGoal();
  const updateMut = useUpdateGoal();
  const deleteMut = useDeleteGoal();

  const items = q.data?.items ?? [];

  return (
    <PlatformAdminLayout>
      <ReferenceMiniCatalog
        title="Цели выращивания"
        subtitle={`Мини-справочник · ${items.length} записей`}
        createLabel="Добавить цель"
        usageBadgeUnit={plural}
        guardMessage="Используется в культурах — нельзя удалить"
        items={items}
        isLoading={q.isLoading}
        onCreate={async (payload) => {
          await createMut.mutateAsync(payload);
          toast.success('Цель создана');
        }}
        onUpdate={async (id, payload) => {
          await updateMut.mutateAsync({ id, payload });
          toast.success('Цель обновлена');
        }}
        onDelete={async (id) => {
          // Отказ ловит и показывает сам ReferenceMiniCatalog (AK-574).
          await deleteMut.mutateAsync(id);
          toast.success('Цель удалена');
        }}
      />
      <p className="mt-3 text-[11px] text-muted-foreground">
        Изменения сразу доступны в multi-select формы культуры.
      </p>
    </PlatformAdminLayout>
  );
}

export default PlatformAdminGrowingGoalsPage;
